import { Component, OnInit } from '@angular/core';
import { SmsService } from '../service/sms.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import * as moment from 'moment-timezone';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-sms-dashboard',
  templateUrl: './sms-dashboard.component.html',
  styleUrls: ['./sms-dashboard.component.css']
})
export class SmsDashboardComponent implements OnInit {
  todayDate;
  user;
  timeZone;
  dashboardtableData;
  dashboardClient;
  totalOutGoing;
   
  smsLabels = {
    confirmation : 'Confirmation',
    wmr : 'WMR / ETA',
    willcall : 'Will Call Initiation',
  }


  constructor(
    private sharedDataService: SharedDataService,
    private smsService: SmsService
  ) { }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .subscribe((data) => {
        if (data) {
          this.timeZone = data.timeZone;
          this.user = data;
          this.todayDate = [
            moment.tz(this.timeZone).startOf("day").toISOString(),
            moment.tz(this.timeZone).endOf("day").toISOString(),
          ];
          this.getSmsDashboardData();
        }

      });
  }

  onDateChange(event) {

    this.todayDate = [
      event[0].tz(this.timeZone).toISOString(),
      event[1].endOf("day").tz(this.timeZone).toISOString(),
    ];

    this.getSmsDashboardData();
  }

  getSmsDashboardData() {
    const payload = {
      startTime: this.todayDate[0],
      endTime: this.todayDate[1]
    }
    this.smsService.getSMSDashboard(payload).subscribe(data => {
      if (data) {
        this.dashboardtableData = data.smsdashboards;
        this.dashboardClient = data.clients[0];
        this.totalOutGoing = this.dashboardtableData.reduce(
          (totalOutGoing, dashboardData) => totalOutGoing + dashboardData.total,
          0
        );

      }
    })
  }

}
